export const ROOT_PATH = '/';
export const QUEUES_WINDOW_PATH = '/queues';
export const EVENTS_WINDOW_PATH = '/events';
export const EVENT_SEARCH_WINDOW_PATH = '/event_search';
export const UNIT_STATUS_SEARCH_WINDOW_PATH = '/unit_status_search';
export const BOLO_SEARCH_WINDOW_PATH = '/bolo_search';
export const FR_UNIT_HISTORY_PATH = '/unit_history';
export const MAP_WINDOW_PATH = '/map';
export const FR_DEX_WINDOW_PATH = '/dex';
export const FR_EVENTS_LIST_PATH = '/events';
export const FR_UNITS_LIST_PATH = '/units';
export const FR_EDIT_UNIT_PATH = '/edit-unit';
export const FR_EVENT_ROOT_PATH = '/event';
export const FR_EVENT_DETAILS_SUB_PATH = 'details';
export const FR_EDIT_EVENT_SUB_PATH = 'edit';
export const FR_CREATE_EVENT_SUB_PATH = 'create';
export const FR_UNASSIGN_CURRENT_USER_UNIT_SUB_PATH = 'unassign';
export const FR_CLEAR_EVENT_SUB_PATH = 'clear';
export const FR_ADD_EVENT_PROPERTY_SUB_PATH = 'add_event_property';
export const FR_EVENT_ATTACHMENTS_SUB_PATH = 'attachments';
export const FR_BOLO_ROOT_PATH = '/bolo';
export const FR_BOLO_ATTACHMENTS_SUB_PATH = 'attachments';
export const FR_CONTACT_LIST_PATH = '/contact-list';
